'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import * as React from 'react';
import { unstable_useForkRef as useForkRef, unstable_isFocusVisible as isFocusVisible } from '@mui/utils';
import { extractEventHandlers } from "../utils/extractEventHandlers.js";
import { useRootElementName } from "../utils/useRootElementName.js";
/**
 *
 * Demos:
 *
 * - [Button](https://mui.com/base-ui/react-button/#hook)
 *
 * API:
 *
 * - [useButton API](https://mui.com/base-ui/react-button/hooks-api/#use-button)
 */ export function useButton() {
    var parameters = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _parameters_disabled = parameters.disabled, disabled = _parameters_disabled === void 0 ? false : _parameters_disabled, focusableWhenDisabled = parameters.focusableWhenDisabled, href = parameters.href, externalRef = parameters.rootRef, tabIndex = parameters.tabIndex, to = parameters.to, type = parameters.type, rootElementNameProp = parameters.rootElementName;
    var buttonRef = React.useRef(null);
    var _React_useState = _sliced_to_array(React.useState(false), 2), active = _React_useState[0], setActive = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(false), 2), focusVisible = _React_useState1[0], setFocusVisible = _React_useState1[1];
    if (disabled && !focusableWhenDisabled && focusVisible) {
        setFocusVisible(false);
    }
    var _useRootElementName = _sliced_to_array(useRootElementName({
        rootElementName: rootElementNameProp !== null && rootElementNameProp !== void 0 ? rootElementNameProp : href || to ? 'a' : undefined,
        componentName: 'Button'
    }), 2), rootElementName = _useRootElementName[0], updateRootElementName = _useRootElementName[1];
    var createHandleMouseLeave = function(otherHandlers) {
        return function(event) {
            var _otherHandlers_onMouseLeave;
            if (focusVisible) {
                event.preventDefault();
            }
            (_otherHandlers_onMouseLeave = otherHandlers.onMouseLeave) === null || _otherHandlers_onMouseLeave === void 0 ? void 0 : _otherHandlers_onMouseLeave.call(otherHandlers, event);
        };
    };
    var createHandleBlur = function(otherHandlers) {
        return function(event) {
            var _otherHandlers_onBlur;
            if (!isFocusVisible(event.target)) {
                setFocusVisible(false);
            }
            (_otherHandlers_onBlur = otherHandlers.onBlur) === null || _otherHandlers_onBlur === void 0 ? void 0 : _otherHandlers_onBlur.call(otherHandlers, event);
        };
    };
    var createHandleFocus = function(otherHandlers) {
        return function(event) {
            var _otherHandlers_onFocus;
            // Fix for https://github.com/facebook/react/issues/7769
            if (!buttonRef.current) {
                buttonRef.current = event.currentTarget;
            }
            if (isFocusVisible(event.target)) {
                var _otherHandlers_onFocusVisible;
                setFocusVisible(true);
                (_otherHandlers_onFocusVisible = otherHandlers.onFocusVisible) === null || _otherHandlers_onFocusVisible === void 0 ? void 0 : _otherHandlers_onFocusVisible.call(otherHandlers, event);
            }
            (_otherHandlers_onFocus = otherHandlers.onFocus) === null || _otherHandlers_onFocus === void 0 ? void 0 : _otherHandlers_onFocus.call(otherHandlers, event);
        };
    };
    var isNativeButton = function() {
        var button = buttonRef.current;
        return rootElementName === 'BUTTON' || rootElementName === 'INPUT' && [
            'button',
            'submit',
            'reset'
        ].includes(button === null || button === void 0 ? void 0 : button.type) || rootElementName === 'A' && (button === null || button === void 0 ? void 0 : button.href);
    };
    var createHandleClick = function(otherHandlers) {
        return function(event) {
            if (!disabled) {
                var _otherHandlers_onClick;
                (_otherHandlers_onClick = otherHandlers.onClick) === null || _otherHandlers_onClick === void 0 ? void 0 : _otherHandlers_onClick.call(otherHandlers, event);
            }
        };
    };
    var createHandleMouseDown = function(otherHandlers) {
        return function(event) {
            var _otherHandlers_onMouseDown;
            if (!disabled) {
                setActive(true);
                document.addEventListener('mouseup', function() {
                    setActive(false);
                }, {
                    once: true
                });
            }
            (_otherHandlers_onMouseDown = otherHandlers.onMouseDown) === null || _otherHandlers_onMouseDown === void 0 ? void 0 : _otherHandlers_onMouseDown.call(otherHandlers, event);
        };
    };
    var createHandleKeyDown = function(otherHandlers) {
        return function(event) {
            var _otherHandlers_onKeyDown;
            (_otherHandlers_onKeyDown = otherHandlers.onKeyDown) === null || _otherHandlers_onKeyDown === void 0 ? void 0 : _otherHandlers_onKeyDown.call(otherHandlers, event);
            if (event.defaultMuiPrevented) {
                return;
            }
            if (event.target === event.currentTarget && !isNativeButton() && event.key === ' ') {
                event.preventDefault();
            }
            if (event.target === event.currentTarget && event.key === ' ' && !disabled) {
                setActive(true);
            }
            // Keyboard accessibility for non interactive elements
            if (event.target === event.currentTarget && !isNativeButton() && event.key === 'Enter' && !disabled) {
                var _otherHandlers_onClick;
                (_otherHandlers_onClick = otherHandlers.onClick) === null || _otherHandlers_onClick === void 0 ? void 0 : _otherHandlers_onClick.call(otherHandlers, event);
                event.preventDefault();
            }
        };
    };
    var createHandleKeyUp = function(otherHandlers) {
        return function(event) {
            var _otherHandlers_onKeyUp;
            // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
            // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
            if (event.target === event.currentTarget) {
                setActive(false);
            }
            (_otherHandlers_onKeyUp = otherHandlers.onKeyUp) === null || _otherHandlers_onKeyUp === void 0 ? void 0 : _otherHandlers_onKeyUp.call(otherHandlers, event);
            // Keyboard accessibility for non interactive elements
            if (event.target === event.currentTarget && !isNativeButton() && !disabled && event.key === ' ' && !event.defaultMuiPrevented) {
                var _otherHandlers_onClick;
                (_otherHandlers_onClick = otherHandlers.onClick) === null || _otherHandlers_onClick === void 0 ? void 0 : _otherHandlers_onClick.call(otherHandlers, event);
            }
        };
    };
    var handleRef = useForkRef(updateRootElementName, externalRef, buttonRef);
    var buttonProps = {};
    if (tabIndex !== undefined) {
        buttonProps.tabIndex = tabIndex;
    }
    if (rootElementName === 'BUTTON') {
        buttonProps.type = type !== null && type !== void 0 ? type : 'button';
        if (focusableWhenDisabled) {
            buttonProps['aria-disabled'] = disabled;
        } else {
            buttonProps.disabled = disabled;
        }
    } else if (rootElementName === 'INPUT') {
        if (type && [
            'button',
            'submit',
            'reset'
        ].includes(type)) {
            if (focusableWhenDisabled) {
                buttonProps['aria-disabled'] = disabled;
            } else {
                buttonProps.disabled = disabled;
            }
        }
    } else if (rootElementName !== '') {
        if (!href && !to) {
            buttonProps.role = 'button';
            buttonProps.tabIndex = tabIndex !== null && tabIndex !== void 0 ? tabIndex : 0;
        }
        if (disabled) {
            buttonProps['aria-disabled'] = disabled;
            buttonProps.tabIndex = focusableWhenDisabled ? tabIndex !== null && tabIndex !== void 0 ? tabIndex : 0 : -1;
        }
    }
    var getRootProps = function() {
        var externalProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var externalEventHandlers = _object_spread({}, extractEventHandlers(parameters), extractEventHandlers(externalProps));
        var props = _object_spread_props(_object_spread({
            type: type
        }, externalEventHandlers, buttonProps, externalProps), {
            onBlur: createHandleBlur(externalEventHandlers),
            onClick: createHandleClick(externalEventHandlers),
            onFocus: createHandleFocus(externalEventHandlers),
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            onKeyUp: createHandleKeyUp(externalEventHandlers),
            onMouseDown: createHandleMouseDown(externalEventHandlers),
            onMouseLeave: createHandleMouseLeave(externalEventHandlers),
            ref: handleRef
        });
        // onFocusVisible can be present on the props or parameters,
        // but it's not a valid React event handler so it must not be forwarded to the inner component.
        // If present, it will be handled by the focus handler.
        delete props.onFocusVisible;
        return props;
    };
    return {
        getRootProps: getRootProps,
        focusVisible: focusVisible,
        setFocusVisible: setFocusVisible,
        active: active,
        rootRef: handleRef
    };
}
